module.exports = __webpack_public_path__ + "static/media/9.69a66819.jpg";